import JupiterImg from '../images/Jupiter.webp';
import MarteImg from '../images/Marte.webp';
import MercurioImg from "../images/Mercurio.webp";
import Netunoimg from '../images/Netuno.webp';
import SaturnoImg from '../images/Saturno.webp';
import TerraImg from '../images/Terra.webp';
import Uranoimg from '../images/Urano.webp';
import VenusImg from '../images/Venus.webp';

const Planets = [
  { name: 'Mercúrio', image: MercurioImg },
  { name: 'Vênus', image: VenusImg },
  { name: 'Terra', image: TerraImg },
  { name: 'Marte', image: MarteImg },
  { name: 'Júpiter', image: JupiterImg },
  { name: 'Saturno', image: SaturnoImg },
  { name: 'Urano', image: Uranoimg },
  { name: 'Netuno', image: Netunoimg },
];

export default Planets;
